import i18n from '@/api/i18n/i18n';

import img from '@/assets/images/img/lanagent.jpg';

export const DEFAULT_CONFIG = {
  name: 'Default',
  browserTitle: 'LanAgent',
  info: 'LanAgent Enterprise',
  copyright: 'Copyright (c) 2005-',
  right: i18n.t('program.networkProfiLLC'),
  details: {
    website: i18n.t('program.website'),
    link: i18n.t('program.link'),
    email: i18n.t('program.email'),
  },
  img,
  productName: i18n.t('program.lanAgent'),
  hiddenRoutes: [],
};
